if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.classList.add('r21-zoom-modal');
      this.addEventListener('pointerdown',e=>{this.touchStart={x:e.clientX,y:e.clientY}});
      this.addEventListener('pointerup',e=>{
        if(e.pointerType==='mouse'||e.target.closest('button,deferred-media,product-model')||!this.touchStart)return;
        if(Math.hypot(e.clientX-this.touchStart.x,e.clientY-this.touchStart.y)<8)this.hide();
      });
      this.querySelector('.r21-media-thumbnails')?.addEventListener('pointerup', e=>e.stopPropagation());
      this.addEventListener('click', e=>{const button=e.target.closest('[data-r21-media]');if(button)this.showActiveMedia(button.dataset.r21Media)});
      this.querySelector('[role=document]').addEventListener('scroll',()=>{
        if(this.transitioning)return;
        const container=this.querySelector('[role=document]'),center=container.getBoundingClientRect().top+container.clientHeight/2;
        const media=[...container.querySelectorAll(':scope>img[data-media-id]')].find(image=>{const r=image.getBoundingClientRect();return r.top<=center&&r.bottom>center});
        if(media)this.markActive(media);
      },{passive:true});
      this.addEventListener('keydown',e=>{
        if(!['ArrowLeft','ArrowRight'].includes(e.key))return;
        const buttons=[...this.querySelectorAll('[data-r21-media]')],index=buttons.findIndex(b=>b.getAttribute('aria-pressed')==='true');
        const next=buttons[(index+(e.key==='ArrowRight'?1:-1)+buttons.length)%buttons.length];
        if(next){e.preventDefault();this.showActiveMedia(next.dataset.r21Media)}
      });
    }
    markActive(media){
      this.querySelectorAll('[role=document]>[data-media-id]').forEach(e=>e.classList.toggle('active',e===media));
      this.querySelectorAll('[data-r21-media]').forEach(e=>e.setAttribute('aria-pressed',String(e.dataset.r21Media===media.dataset.mediaId)));
    }
    showActiveMedia(id){
      const container=this.querySelector('[role=document]');
      const media=[...container.querySelectorAll(':scope>[data-media-id]')].find(e=>e.dataset.mediaId===id);
      if(!media)return;
      this.markActive(media);
      container.scrollTop+=media.getBoundingClientRect().top-container.getBoundingClientRect().top;
      if(media.nodeName==='DEFERRED-MEDIA')media.loadContent();
      return media;
    }
    async morph(image,from,to){
      const clone=image.cloneNode();clone.removeAttribute('id');clone.removeAttribute('srcset');clone.removeAttribute('sizes');clone.src=image.currentSrc||image.src;
      Object.assign(clone.style,{position:'fixed',left:from.left+'px',top:from.top+'px',width:from.width+'px',height:from.height+'px',maxWidth:'none',margin:'0',padding:'0',border:'0',objectFit:'fill',zIndex:'10000',pointerEvents:'none'});
      document.body.append(clone);this.transitioning=true;this.classList.add('r21-zoom-transition');
      const animation=clone.animate([{left:from.left+'px',top:from.top+'px',width:from.width+'px',height:from.height+'px'},{left:to.left+'px',top:to.top+'px',width:to.width+'px',height:to.height+'px'}],{duration:420,easing:'cubic-bezier(.22,1,.36,1)',fill:'forwards'});
      await animation.finished.catch(()=>{});
      return ()=>{clone.remove();this.classList.remove('r21-zoom-transition');this.transitioning=false};
    }
    async show(opener){
      if(this.transitioning||this.hasAttribute('open'))return;
      this.returnScroll={left:scrollX,top:scrollY,behavior:'instant'};
      this.originImage=opener.closest('modal-opener')?.querySelector('img');
      const origin=this.originImage?.getBoundingClientRect();
      super.show(opener);
      document.documentElement.classList.add('r21-image-viewer-open');
      const active=this.showActiveMedia(opener.dataset.mediaId);
      if(origin&&active?.tagName==='IMG'&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
        const finish=await this.morph(this.originImage,origin,active.getBoundingClientRect());
        await Promise.race([active.decode().catch(()=>{}),new Promise(resolve=>setTimeout(resolve,1500))]);finish();
      }
    }
    async hide(){
      if(this.transitioning||!this.hasAttribute('open'))return;
      const active=this.querySelector('[role=document]>.active');
      let finish;
      if(active?.tagName==='IMG'&&this.originImage&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
        finish=await this.morph(active,active.getBoundingClientRect(),this.originImage.getBoundingClientRect());
      }
      super.hide();document.documentElement.classList.remove('r21-image-viewer-open');
      if(this.returnScroll)scrollTo(this.returnScroll);
      finish?.();
    }
  });
}
